import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentSuccess from '../components/PaymentSuccess';
import { useEntitlements } from '../contexts/EntitlementContext';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { refresh } = useEntitlements();
  const [done, setDone] = useState(false);

  useEffect(() => {
    refresh().finally(() => setDone(true));
  }, [refresh]);

  return (
    <PaymentSuccess
      sessionId={sessionId}
      ready={done}
      onContinue={() => navigate('/', { replace: true })}
    />
  );
}
